import { render, staticRenderFns } from "./ContadoresView.vue?vue&type=template&id=b6311280&scoped=true"
import script from "./ContadoresView.vue?vue&type=script&lang=js"
export * from "./ContadoresView.vue?vue&type=script&lang=js"
import style0 from "./ContadoresView.vue?vue&type=style&index=0&id=b6311280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6311280",
  null
  
)

export default component.exports